import React, { useEffect } from 'react';
// import DataList from '../../sharedcomponents/dataList/dataList';
import { useState, Downgraded } from '@hookstate/core';
import { Paper, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import UserListDialog from '../../sharedcomponents/userList/userListDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import { useAuthState } from '../../stores/authStore';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import EditTemplate from '../Invitation/editTemplate';
import EditTicketList from './editTicketList';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import SendEmail from '../Invitation/sendEmail';
import {
    NO_ACCESS_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import { excelFileType } from '../../constants/Constant';
import AccordianCommonRequests from '../../sharedcomponents/commonRequest/accordianCommonRequest';
import { generatePath, useHistory } from 'react-router-dom';
import RouteConstants from '../../constants/routeConstants';
import AppConstants from '../../constants/appConstants';
import TicketSettingsDialog from '../../sharedcomponents/userList/ticketSettingsDialog';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));
const TicketList = (props) => {
    const loading = useState(false);
    const openSettingDialog = useState(false);
    const classes = useStyles();
    const allStarticketList = useState([]);
    const fullAllStarticketList = useState([]);
    const allInvitationInfo = useState()
    const overallParticipants = useState([]);
    const users = useState([]);
    const authState = useAuthState();
    const eventState = useState([]);
    const openNoteDialog = useState(false);
    // const eventStateDetail = useEventState();
    const eventData = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const openUserDialog = useState(false);
    const allStarTicketInfo = useState(null);
    const openEditTemplate = useState(false);
    const openSendEmail = useState(false);
    const setAll = useState(false);
    const allNote = useState(false);
    const requestNote = useState(null);
    const approveLoader = useState(false);
    const rejectLoader = useState(false);
    const displayName = useState(null);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const history = useHistory();
    const openDialog = useState(false);
    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const requestPending = useState(null);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const approveloading = useState({
        loading: false,
        index: 0
    })
    const rejectloading = useState({
        loading: false,
        index: 0
    })
    const [templateInfo, setTemplateInfo] = React.useState([]);
    const userID = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.ALL_STAR_TICKET).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    // useEffect(() => {
    //     const userInfo = Helper.getStorage('userInfo');

    //     if (eventStateDetail) {
    //         if (Helper.isAdminUser(userInfo)) {
    //             setModPermission(FULL_PERMISSION);
    //         }
    //         else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
    //             setModPermission(FULL_PERMISSION);
    //         }
    //         else {
    //             setModPermission(NO_ACCESS_PERMISSION);
    //         }
    //     }
    // }, [eventStateDetail]);
    useEffect(() => {
        if (
            props.modPermission &&
            props.modPermission != NO_ACCESS_PERMISSION
        ) {
            const fetchDetails = async () => {
                let usersList = await getAllStarTicketList();
                if (eventState && eventState.get().length == 0) {
                    const eventInfo = Helper.getStorage('eventInfo');
                    ApiHelper.get(
                        APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                            eventInfo.eventID
                        )
                    )
                        .then((res) => {
                            let newEventState = res.data.rows;
                            let originalUsers = usersList;
                            let filteredEventState = newEventState.filter(
                                (x) =>
                                    !originalUsers
                                        .map((y) => y.actualData.userID)
                                        .includes(x.userID)
                            );
                            eventState.set(filteredEventState);
                            const participants = res.data.rows.filter(
                                (participant) =>
                                    AppConstants.EVENT_ROLES_VALUES.indexOf(
                                        participant.roleName
                                    ) == -1
                            );
                            overallParticipants.set(participants);
                        })
                        .catch((err) => {
                            //... Check if user's session has expired
                            if (err.response && err.response.status === 401) {
                                console.log(err);
                            }
                        });
                }
            };
            fetchDetails();

            // ApiHelper.get(
            //     APIURLConstants.GET_TEMPLATES(eventData.get().eventID)
            // ).then((res) => {
            //     setTemplateInfo(res.data);
            // });
            setTemplateInfo([]);
            // const pageInfo = pagingInfo.attach(Downgraded).get();
            // if (pageInfo.itemsPerPage)
            // {
            //     getAllStarTicketList();
            // }
        }
    }, [props.modPermission]);

    const getAllStarTicketList = () => {
        const userInfo = Helper.getStorage('userInfo');

        let allData;
        loading.set(true);
        return ApiHelper.get(
            APIURLConstants.GET_TICKET_ALLSTAR(
                eventData.get().eventID,
                userInfo.userID,
                1
            )
        )
            .then((res) => {
                let data = res.data.rows;
                allData = res;
                allInvitationInfo.set(data)
                let usersData = [];
                let allUsersData = []
                const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                if (data.length > 0) {
                    data.map((item) => {
                        let newItem = []
                        const dummyObj = { defaultSetting: null, eventID: null, reference: null, setting: "[{\"HotelTicketSettingID\":0,\"UserID\":0,\"EventID\":0,\"TicketSetting\":\"{\\\"ticketFriCompCount\\\":\\\"0\\\",\\\"ticketSatCompCount\\\":\\\"0\\\",\\\"ticketSunCompCount\\\":\\\"0\\\",\\\"ticketFriPurCount\\\":\\\"0\\\",\\\"ticketSatPurCount\\\":\\\"0\\\",\\\"ticketSunPurCount\\\":\\\"0\\\",\\\"ticketFriAddPurCount\\\":\\\"0\\\",\\\"ticketSatAddPurCount\\\":\\\"0\\\",\\\"ticketSunAddPurCount\\\":\\\"0\\\"}\",\"CInstruction\":\"\",\"PInstruction\":\"\",\"OInstruction\":\"\",\"Level\":\"P\"}]", ticketSettingID: 0, userID: 0 }
                        if (item.ticketAllStarSetting) {
                            newItem.push(item)
                        } else {
                            newItem.push({ ...item, ticketAllStarSetting: dummyObj })
                        }
                        item = newItem[0];
                        let friUsedCount = 0;
                        let satUsedCount = 0;
                        let sunUsedCount = 0;
                        if (item.ticketAccordian && item.ticketAccordian.length > 0) {
                            item.ticketAccordian.map((val) => {
                                if (val.ticketNightID === 1) {
                                    friUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 2) {
                                    satUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 3) {
                                    sunUsedCount = val.ticketCount
                                }
                            })
                        }
                        let friAddUsedCount = 0;
                        let satAddUsedCount = 0;
                        let sunAddUsedCount = 0;
                        if (item.ticketAddPurchaseAccordian && item.ticketAddPurchaseAccordian.length > 0) {
                            item.ticketAddPurchaseAccordian.map((val) => {
                                if (val.ticketNightID === 1) {
                                    friAddUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 2) {
                                    satAddUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 3) {
                                    sunAddUsedCount = val.ticketCount
                                }
                            })
                        }
                        allUsersData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketAllStarID',
                                    width: '0.05',
                                },
                                {
                                    label: 'Name',
                                    key: 'participant',
                                    participant: item.participant,
                                    showLabel: false,
                                    width: '0.20',
                                    inColumn: true,
                                    showEmail: true,
                                    toEmail: item.email,
                                },
                                {
                                    label: 'Submitted Date',
                                    key: 'date',
                                    date: Helper.FormatDate(item.createdDate),
                                    width: '0.10',
                                    inColumn: true,
                                },
                                {
                                    label: 'Comp',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    inColumn: true,
                                },
                                {
                                    label: 'Purchase',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    friUsedCount: friUsedCount,
                                    satUsedCount: satUsedCount,
                                    sunUsedCount: sunUsedCount,
                                    inColumn: true,
                                },
                                {
                                    label: 'Add Purchase',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    friAddUsedCount: friAddUsedCount,
                                    satAddUsedCount: satAddUsedCount,
                                    sunAddUsedCount: sunAddUsedCount,
                                    inColumn: true,
                                },
                                {
                                    label: 'Status',
                                    key: 'status',
                                    status: item.requestStatus,
                                    width: '0.06',
                                    showStatusIcon: true,
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                {
                                    label: 'Action',
                                    key: 'All',
                                    edit: 'All',
                                    width: '0.14',
                                },
                            ],
                            selected: false,
                        });
                    })
                    data.slice(indexOfFirstRecord, indexOfLastRecord).map((item) => {
                        let newItem = []
                        const dummyObj = { defaultSetting: null, eventID: null, reference: null, setting: "[{\"HotelTicketSettingID\":0,\"UserID\":0,\"EventID\":0,\"TicketSetting\":\"{\\\"ticketFriCompCount\\\":\\\"0\\\",\\\"ticketSatCompCount\\\":\\\"0\\\",\\\"ticketSunCompCount\\\":\\\"0\\\",\\\"ticketFriPurCount\\\":\\\"0\\\",\\\"ticketSatPurCount\\\":\\\"0\\\",\\\"ticketSunPurCount\\\":\\\"0\\\",\\\"ticketFriAddPurCount\\\":\\\"0\\\",\\\"ticketSatAddPurCount\\\":\\\"0\\\",\\\"ticketSunAddPurCount\\\":\\\"0\\\"}\",\"CInstruction\":\"\",\"PInstruction\":\"\",\"OInstruction\":\"\",\"Level\":\"P\"}]", ticketSettingID: 0, userID: 0 }
                        if (item.ticketAllStarSetting) {
                            newItem.push(item)
                        } else {
                            newItem.push({ ...item, ticketAllStarSetting: dummyObj })
                        }
                        item = newItem[0];
                        let friUsedCount = 0;
                        let satUsedCount = 0;
                        let sunUsedCount = 0;
                        if (item.ticketAccordian && item.ticketAccordian.length > 0) {
                            item.ticketAccordian.map((val) => {
                                if (val.ticketNightID === 1) {
                                    friUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 2) {
                                    satUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 3) {
                                    sunUsedCount = val.ticketCount
                                }
                            })
                        }
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        data.map((item) => {
                            if (item.status === 2) {
                                approved += 1;
                            }
                            if (item.status === 1) {
                                pending += 1;
                            }
                            if (item.status === 3) {
                                rejected += 1;
                            }
                        })
                        let friAddUsedCount = 0;
                        let satAddUsedCount = 0;
                        let sunAddUsedCount = 0;
                        if (item.ticketAddPurchaseAccordian && item.ticketAddPurchaseAccordian.length > 0) {
                            item.ticketAddPurchaseAccordian.map((val) => {
                                if (val.ticketNightID === 1) {
                                    friAddUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 2) {
                                    satAddUsedCount = val.ticketCount
                                } else if (val.ticketNightID === 3) {
                                    sunAddUsedCount = val.ticketCount
                                }
                            })
                        }
                        usersData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'ticketAllStarID',
                                    width: '0.05',
                                },
                                {
                                    label: 'Name',
                                    key: 'participant',
                                    participant: item.participant,
                                    showLabel: false,
                                    width: '0.20',
                                    inColumn: true,
                                    showEmail: true,
                                    toEmail: item.email,
                                },
                                {
                                    label: 'Submitted Date',
                                    key: 'date',
                                    date: Helper.FormatDate(item.createdDate),
                                    width: '0.10',
                                    inColumn: true,
                                },
                                {
                                    label: 'Comp',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    inColumn: true,
                                },
                                {
                                    label: 'Purchase',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    friUsedCount: friUsedCount,
                                    satUsedCount: satUsedCount,
                                    sunUsedCount: sunUsedCount,
                                    inColumn: true,
                                },
                                {
                                    label: 'Add Purchase',
                                    key: 'ticketSettings',
                                    width: '0.15',
                                    friAddUsedCount: friAddUsedCount,
                                    satAddUsedCount: satAddUsedCount,
                                    sunAddUsedCount: sunAddUsedCount,
                                    inColumn: true,
                                },
                                {
                                    label: 'Status',
                                    key: 'status',
                                    status: item.requestStatus,
                                    width: '0.06',
                                    showStatusIcon: true,
                                    alignCenter: true,
                                    inColumn: true,
                                },
                                {
                                    label: 'Action',
                                    key: 'All',
                                    edit: 'All',
                                    width: '0.14',
                                },
                                { showChips: true },
                            ],
                            selected: false,
                        });
                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    });
                }
                allStarticketList.set(usersData);
                fullAllStarticketList.set(allUsersData);
                users.set(usersData);
                if (pagingInfo.get().noOfPages == null) {
                    pagingInfo.set({
                        ...pagingInfo,
                        currentPage: pagingInfo.get().currentPage,
                        itemsPerPage: pagingInfo.get().itemsPerPage,
                        noOfPages: Math.ceil(
                            data.length / pagingInfo.get().itemsPerPage
                        ),
                    });
                }
                if (
                    overallParticipants &&
                    overallParticipants.get().length !== 0
                ) {
                    let newEventState = overallParticipants
                        .attach(Downgraded)
                        .get();
                    let filteredEventState = newEventState.filter(
                        (x) =>
                            !usersData
                                .map((y) => y.actualData.userID)
                                .includes(x.userID)
                    );
                    eventState.set(filteredEventState);
                }
                loading.set(false);
                props.getSentData(allData)
                return usersData;

            })
            .catch((err) => {
                console.log(err);
                loading.set(false);
                props.getSentData(null)
                return [];

            });
    };
    const editAll = () => {
        const selected = allStarticketList
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Invitation first',
            });
        } else {
            let selectedIds = [];
            let templateIDs = [];
            let data = [];
            let templateDetails;
            allStarticketList.get().map((user) => {
                if (user.selected === true) {
                    selectedIds.push(user.actualData.invitationID);
                    templateIDs.push(user.actualData.templateID);
                }
            });
            if (templateIDs.every((val, i, arr) => val === arr[0])) {
                data = templateInfo.rows.filter((el) => {
                    return el.templateID === templateIDs[0];
                });

                if (data.length > 0) {
                    templateDetails = {
                        ccEmailID: data[0].ccEmailID,
                        bccEmailID: data[0].bccEmailID,
                        templateID: data[0].templateID,
                        attachments: data[0].attachments,
                        body: data[0].body,
                        subject: data[0].subject,
                    };
                }
                else {
                    templateDetails = null;
                }

            } else {
                templateDetails = null;
            }

            openUserDialog.set(true);

            let setectedId = {
                selectedId: selectedIds.join(','),
                editAll: true,
                templateData: templateDetails,
            };
            allStarTicketInfo.set(setectedId);
        }
    };

    const redirectToCreate = () => {
        // openDialog.set(true);
        // console.log("props.history", overallParticipants.attach(Downgraded).get());

        let registeredIds = allStarticketList.attach(Downgraded).get().map(x => x.actualData.userID)
        let filteredParticipants = overallParticipants.attach(Downgraded).get().filter(x => !registeredIds.includes(x.userID))
        history.push({
            pathname: generatePath(RouteConstants.All_STAR_END_USER_TIKCETS, {
                eventID: eventData.get().eventID,
            }),
            state: { adminParticipantList: filteredParticipants, editMode: false },
        });
    };
    const handleClose = () => {
        openDialog.set(false);
    };
    const editUser = (info) => {
        const row = info.actualData;
        let registeredIds = allStarticketList.attach(Downgraded).get().map(x => x.actualData.userID)
        let index = registeredIds.indexOf(row.userID)
        registeredIds.splice(index, 1);
        let filteredParticipants = overallParticipants.attach(Downgraded).get().filter(x => !registeredIds.includes(x.userID))

        allStarTicketInfo.set(info);
        const path = generatePath(RouteConstants.All_STAR_END_USER_TIKCETS, {
            eventID: eventData.eventID.value
        });

        history.push({
            pathname: path,
            state: {
                ticketState: row, adminParticipantList: filteredParticipants,
                editMode: true,
            },
        });
    };
    const closeEditUser = () => {
        openUserDialog.set(false);
    };
    // const editTemplate = (info) => {
    //     openEditTemplate.set(true);
    //     allStarTicketInfo.set(info.actualData);
    // };
    const closeEditTemplate = () => {
        openEditTemplate.set(false);
    };

    const editSendEmail = (info) => {
        openSendEmail.set(true);
        allStarTicketInfo.set(info.actualData);
    };
    const closeSendEmail = () => {
        openSendEmail.set(false);
    };

    const deleteTicketList = () => {
        const selected = allStarticketList
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullAllStarticketList
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Ticket first',
            });
        } else {
            let message =
                selected.length == users.get().length
                    ? 'Do you want to delete all Ticket?'
                    : 'Do you want to delete selected Ticket?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getAllStarTicketList();
    };
    const handleConfirmation = () => {
        let deleteUsers = [];
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');

        allStarticketList.get().map((user) => {
            if (user.selected === true) {
                deleteUsers.push(user.actualData.userID);
            }
        });
        fullAllStarticketList.get().map((user) => {
            if (user.selected === true) {
                deleteUsers.push(user.actualData.userID);
            }
        });
        // console.log("deleteUsers", deleteUsers);

        ApiHelper.post(APIURLConstants.DELETE_ALLSTAR_TICKET, {
            ids: deleteUsers.join(','),
            eventID: eventInfo.eventID,
            modifiedBy: userInfo.userID,
        })
            .then((res) => {
                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Ticket List deleted successfully',
                    });
                    setShowSearchRec(false);
                    getAllStarTicketList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                } else {
                    message = 'Ticket List deleted Successfully';
                    setSnackBarProps({
                        snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: message,
                    });
                }
                getAllStarTicketList();
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const callExport = () => {
        if (allStarticketList.attach(Downgraded).length !== 0) {
            const selected = allStarticketList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullAllStarticketList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allStarticketList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullAllStarticketList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        }
    };

    const generateExcelReport = async (result) => {
        let selectedDatas = [];

        if (result.length > 0) {
            result.map((item) => {
                selectedDatas.push(item);
            });
        }
        let data = [];
        selectedDatas.forEach((row) => {
            let ticketJsonSettingData = []
            if (row.actualData?.ticketAllStarSetting.setting?.length > 0) {
                const jsonP = JSON.parse(row.actualData.ticketAllStarSetting.setting);
                if (jsonP.length > 0) {
                    ticketJsonSettingData.push(JSON.parse(jsonP[0].TicketSetting))
                }
            }
            const arrayHashmap = row.actualData.ticketAllStars && row.actualData.ticketAllStars.reduce((obj, item) => {
                // console.log(obj,item); 
                obj[item.summary] ? obj[item.summary].ticketAllStarDetails.push(...item.ticketAllStarDetails) : (obj[item.summary] = { ...item });
                return obj;
            }, {});
            const arrayHashmap1 = row.actualData.ticketAllStars && row.actualData.ticketAllStars.reduce((obj, item) => {
                // console.log(obj,item); 
                obj[item.summary] ? obj[item.summary].ticketAllStarAdditionalPurchase.push(...item.ticketAllStarAdditionalPurchase) : (obj[item.summary] = { ...item });
                return obj;
            }, {});
            // obj[item.summary] ? obj[item.summary].ticketAllStarAdditionalPurchase.push(...item.ticketAllStarAdditionalPurchase) : (obj[item.summary] = { ...item });
            // const newValueArrray = 
            const mergedArray = Object.values(arrayHashmap);
            if (mergedArray.length > 0) {
                mergedArray.map((rows, j) => {
                    // console.log("rows",rows,j);
                    const newObjvalues = Object.values(arrayHashmap1)
                    // console.log(newObjvalues);

                    rows.ticketAllStarAdditionalPurchase = rows.ticketAllStarAdditionalPurchase.length === 0 ? (newObjvalues[j].ticketAllStarAdditionalPurchase.length > 0 ? arrayHashmap1[j].ticketAllStarAdditionalPurchase : []) : rows.ticketAllStarAdditionalPurchase
                    // let fCLP = 0
                    // let fCUP = 0
                    // let fCLC = 0
                    // let fCUC = 0

                    // let sCLP = 0
                    // let sCUP = 0
                    // let sCLC = 0
                    // let sCUC = 0

                    // let suCLP = 0
                    // let suCUP = 0
                    // let suCLC = 0
                    // let suCUC = 0

                    // let afCLP = 0
                    // let afCUP = 0
                    // let afCLC = 0
                    // let afCUC = 0

                    // let asCLP = 0
                    // let asCUP = 0
                    // let asCLC = 0
                    // let asCUC = 0

                    // let asuCLP = 0
                    // let asuCUP = 0
                    // let asuCLC = 0
                    // let asuCUC = 0
                    // var uniqPurchase = rows.ticketAllStarDetails.filter(function({ticketAllStarID}) {
                    //     return !this[ticketAllStarID] && (this[ticketAllStarID] = ticketAllStarID)
                    //   }, {})
                    //   console.log("uniqPurchase",uniqPurchase);
                    // console.log("rows",rows);
                    let fCLPArr = [];
                    let sCLPArr = [];
                    let suCLPArr = [];
                    let fCUPArr = [];
                    let sCUPArr = [];
                    let suCUPArr = [];
                    let afCLPArr = [];
                    let asCLPArr = [];
                    let asuCLPArr = [];
                    let afCUPArr = [];
                    let asCUPArr = [];
                    let asuCUPArr = [];
                    rows.ticketAllStarDetails.map((value) => {
                        if (value.ticketNightID === 1) {
                            if (value.subTypeName === "Lower Bowl") {
                                let fIndex = fCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (fIndex > -1) {
                                    fCLPArr[fIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    fCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // fCLP=value.price
                                // fCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let fIndex = fCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (fIndex > -1) {
                                    fCUPArr[fIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    fCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }

                                // fCUP=value.price 
                                // fCUC+=value.ticketCount
                            }
                        } else if (value.ticketNightID === 2) {
                            if (value.subTypeName === "Lower Bowl") {
                                let sIndex = sCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (sIndex > -1) {
                                    sCLPArr[sIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    sCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }

                                // sCLP=value.price 
                                // sCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let sIndex = sCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (sIndex > -1) {
                                    sCUPArr[sIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    sCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // sCUP=value.price 
                                // sCUC+=value.ticketCount
                            }
                        } else if (value.ticketNightID === 3) {
                            if (value.subTypeName === "Lower Bowl") {
                                let suIndex = suCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (suIndex > -1) {
                                    suCLPArr[suIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    suCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // suCLP=value.price 
                                // suCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let suIndex = suCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (suIndex > -1) {
                                    suCUPArr[suIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    suCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // suCUP=value.price 
                                // suCUC+=value.ticketCount
                            }
                        }
                    })
                    // var uniqAddPurchase = rows.ticketAllStarAdditionalPurchase.filter(function({ticketAllStarID}) {
                    //     return !this[ticketAllStarID] && (this[ticketAllStarID] = ticketAllStarID)
                    //   }, {})
                    //   console.log("uniqAddPurchase",uniqAddPurchase);
                    rows.ticketAllStarAdditionalPurchase.map((value) => {
                        if (value.ticketNightID === 1) {
                            if (value.subTypeName === "Lower Bowl") {
                                let fIndex = afCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (fIndex > -1) {
                                    afCLPArr[fIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    afCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // afCLP=value.price 
                                // afCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let fIndex = afCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (fIndex > -1) {
                                    afCUPArr[fIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    afCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // afCUP=value.price 
                                // afCUC+=value.ticketCount
                            }
                        } else if (value.ticketNightID === 2) {
                            if (value.subTypeName === "Lower Bowl") {
                                let sIndex = asCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (sIndex > -1) {
                                    asCLPArr[sIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    asCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // asCLP=value.price 
                                // asCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let sIndex = asCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (sIndex > -1) {
                                    asCUPArr[sIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    asCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // asCUP=value.price 
                                // asCUC+=value.ticketCount
                            }
                        } else if (value.ticketNightID === 3) {
                            if (value.subTypeName === "Lower Bowl") {
                                let suIndex = asuCLPArr.findIndex(fitem => fitem.value == value.price);
                                if (suIndex > -1) {
                                    asuCLPArr[suIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    asuCLPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // asuCLP=value.price 
                                // asuCLC+=value.ticketCount
                            } else if (value.subTypeName === "Upper Bowl") {
                                let suIndex = asuCUPArr.findIndex(fitem => fitem.value == value.price);
                                if (suIndex > -1) {
                                    asuCUPArr[suIndex]['count'] += value.ticketCount;
                                }
                                else {
                                    asuCUPArr.push({
                                        value: value.price,
                                        count: value.ticketCount
                                    });
                                }
                                // asuCUP=value.price 
                                // asuCUC+=value.ticketCount
                            }
                        }
                    })
                    // tickets strings for purchase - start
                    let fPurchaseTicket = '';
                    if (fCLPArr.length > 0) {
                        fCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                fPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    if (fCUPArr.length > 0) {
                        fCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                fPurchaseTicket += 'Upper Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }

                    let sPurchaseTicket = '';
                    if (sCLPArr.length > 0) {
                        sCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                sPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    if (sCUPArr.length > 0) {
                        sCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                sPurchaseTicket += 'Upper Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }

                    let suPurchaseTicket = '';
                    if (suCLPArr.length > 0) {
                        suCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                suPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    if (suCUPArr.length > 0) {
                        suCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                suPurchaseTicket += 'Upper Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    // tickets strings for purchase - end

                    // tickets strings for addpurchase - start
                    let afPurchaseTicket = '';
                    if (afCLPArr.length > 0) {
                        afCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                afPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        });
                    }
                    if (afCUPArr.length > 0) {
                        afCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                afPurchaseTicket += 'Upper Bowl ' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }

                    let asPurchaseTicket = '';
                    if (asCLPArr.length > 0) {
                        asCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                asPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    if (asCUPArr.length > 0) {
                        asCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                asPurchaseTicket += 'Upper Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }

                    let asuPurchaseTicket = '';
                    if (asuCLPArr.length > 0) {
                        asuCLPArr.map(fitem => {
                            if (fitem.count > 0) {
                                asuPurchaseTicket += 'Lower Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    if (asuCUPArr.length > 0) {
                        asuCUPArr.map(fitem => {
                            if (fitem.count > 0) {
                                asuPurchaseTicket += 'Upper Bowl $' + fitem.value + ' - ' + fitem.count + '\n';
                            }
                        })
                    }
                    // tickets strings for addpurchase - end

                    data.push({
                        "Participant": row.actualData.participant,
                        "Comp Contact Name": row.actualData.contactName,
                        "Comp Contact Email": row.actualData.contactEmail,
                        "CC": (rows.summary !== '' || rows.summary !== null) ? '****-' + rows.summary + '-' + rows.cardName : '',
                        "Token": rows.token !== "" ? rows.token : "",
                        "Comp Contact No": row.actualData.contactNo,
                        "Comp Fri Night": ticketJsonSettingData[0].ticketFriCompCount,
                        // TotalPurchaseFri: fC === 0 ? '' : fC,
                        "Purchase Fri Night Breakout": fPurchaseTicket.length > 0 ? fPurchaseTicket.substring(0, fPurchaseTicket.length - 1) : '',

                        // (fCLC > 0 ? 'Lower Bowl $'+fCLP+' - '+ fCLC : '' ) + (fCUC > 0 ? ' \n'+ 'Upper Bowl $'+fCUP+' - '+ fCUC : ''),
                        // TotalPurchaseFriCost: fPC === 0 ? '' : fPC,
                        // TotalAddPurchaseFri: afC === 0 ? '' : afC,
                        "Add Purchase Fri Night Breakout": afPurchaseTicket.length > 0 ? afPurchaseTicket.substring(0, afPurchaseTicket.length - 1) : '',
                        //(afCLC > 0 ? 'Lower Bowl $'+afCLP+' - '+ afCLC : '' ) + (afCUC > 0 ? ' \n'+ 'Upper Bowl $'+afCUP+' - '+ afCUC : ''),
                        // TotalAddPurchaseFriCost: afPC === 0 ? '' : afPC,

                        "Comp Sat Night": ticketJsonSettingData[0].ticketSatCompCount,
                        // TotalPurchaseSat: saC === 0 ? '' : saC,
                        "Purchase Sat Night Breakout": sPurchaseTicket.length > 0 ? sPurchaseTicket.substring(0, sPurchaseTicket.length - 1) : '',
                        // (sCLC > 0 ? 'Lower Bowl $'+sCLP+' - '+ sCLC : '' ) + (sCUC > 0 ? ' \n'+ 'Upper Bowl $'+sCUP+' - '+ sCUC : ''),
                        // TotalPurchaseSatCost: saPC === 0 ? '' : saPC,
                        // TotalAddPurchaseSat: asaC === 0 ? '' : asaC,
                        "Add Purchase Sat Night Breakout": asPurchaseTicket.length > 0 ? asPurchaseTicket.substring(0, asPurchaseTicket.length - 1) : '',
                        // (asCLC > 0 ? 'Lower Bowl $'+asCLP+' - '+ asCLC : '' ) + (asCUC > 0 ? ' \n'+ 'Upper Bowl $'+asCUP+' - '+ asCUC : ''),
                        // TotalAddPurchaseSatCost: asaPC === 0 ? '' : asaPC,

                        "Comp Sun Night": ticketJsonSettingData[0].ticketSunCompCount,
                        // TotalPurchaseSun: suC === 0 ? '' : suC,
                        "Purchase Sun Night Breakout": suPurchaseTicket.length > 0 ? suPurchaseTicket.substring(0, suPurchaseTicket.length - 1) : '',
                        // (suCLC > 0 ? 'Lower Bowl $'+suCLP+' - '+ suCLC : '' ) + (suCUC > 0 ? ' \n'+ 'Upper Bowl $'+suCUP+' - '+ suCUC : ''),
                        // TotalPurchaseSunCost: suPC === 0 ? '' : suPC,
                        // TotalAddPurchaseSun: asuC === 0 ? '' : asuC,
                        "Add Purchase Sun Night Breakout": asuPurchaseTicket.length > 0 ? asuPurchaseTicket.substring(0, asuPurchaseTicket.length - 1) : '',
                        // (asuCLC > 0 ? 'Lower Bowl $'+asuCLP+' - '+ asuCLC : '' ) + (asuCUC > 0 ? ' \n'+ 'Upper Bowl $'+asuCUP+' - '+ asuCUC : ''),
                        // TotalAddPurchaseSunCost: asuPC  === 0 ? '' : asuPC,

                        "Status": row.actualData.requestStatus,
                        "Note": row.actualData.notes,
                        "SubmittedBy": row.actualData.createdByName,
                        "SubmittedDate": Helper.FormatDateTime(row.actualData.createdDate),
                    });
                });
            } else {
                data.push({
                    "Participant": row.actualData.participant,
                    "Comp Contact Name": row.actualData.contactName,
                    "Comp Contact Email": row.actualData.contactEmail,
                    "CC": "",
                    "Token": "",
                    "Comp Contact No": row.actualData.contactNo,

                    "Comp Fri Night": ticketJsonSettingData[0].ticketFriCompCount,
                    // TotalPurchaseFri: '',
                    "Purchase Fri Night Breakout": '',
                    // TotalPurchaseFriCost: '',
                    // TotalAddPurchaseFri: '',
                    "Add Purchase Fri Night Breakout": '',
                    // TotalAddPurchaseFriCost: '',

                    "Comp Sat Night": ticketJsonSettingData[0].ticketSatCompCount,
                    // TotalPurchaseSat: '',
                    "Purchase Sat Night Breakout": '',
                    // TotalPurchaseSatCost: '',
                    // TotalAddPurchaseSat: '',
                    "Add Purchase Sat Night Breakout": '',
                    // TotalAddPurchaseSatCost: '',

                    "Comp Sun Night": ticketJsonSettingData[0].ticketSunCompCount,
                    // TotalPurchaseSun: '',
                    "Purchase Sun Night Breakout": '',
                    // TotalPurchaseSunCost: '',
                    // TotalAddPurchaseSun: '',
                    "Add Purchase Sun Night Breakout": '',
                    // TotalAddPurchaseSunCost: '',

                    "Status": row.actualData.requestStatus,
                    "Note": row.actualData.notes,
                    "SubmittedBy": row.actualData.createdByName,
                    "SubmittedDate": Helper.FormatDateTime(row.actualData.createdDate),
                });
            }
            data.push({
                "Participant": "",
                "Comp Contact Name": "",
                "Comp Contact Email": "",
                "CC": "",
                "Token": "",
                "Comp Contact No": "",

                "Comp Fri Night": "",
                // TotalPurchaseFri: '',
                "Purchase Fri Night Breakout": '',
                // TotalPurchaseFriCost: '',
                // TotalAddPurchaseFri: '',
                "Add Purchase Fri Night Breakout": '',
                // TotalAddPurchaseFriCost: '',

                "Comp Sat Night": "",
                // TotalPurchaseSat: '',
                "Purchase Sat Night Breakout": '',
                // TotalPurchaseSatCost: '',
                // TotalAddPurchaseSat: '',
                "Add Purchase Sat Night Breakout": '',
                // TotalAddPurchaseSatCost: '',

                "Comp Sun Night": "",
                // TotalPurchaseSun: '',
                "Purchase Sun Night Breakout": '',
                // TotalPurchaseSunCost: '',
                // TotalAddPurchaseSun: '',
                "Add Purchase Sun Night Breakout": '',
                // TotalAddPurchaseSunCost: '',

                "Status": "",
                "Note": "",
                "SubmittedBy": "",
                "SubmittedDate": "",
            });
        })
        console.log("data",data);
        // data.unshift(header);
        Helper.downloadStyledReport(data, `AllStarTickets-Report`);
        getAllStarTicketList()

        // Helper.downloadReport(data, `AllStarTickets-Report`);
    };

    const handleImportInvitation = (attachmentDocument) => {
        if (attachmentDocument && attachmentDocument.target.files[0]) {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type)) {
                let form = new FormData();
                form.append("attachedFile", uploadFile);
                form.append("eventId", eventData.attach(Downgraded).get().eventID);
                // form.append("userId", userInfo.attach(Downgraded).get().userID);
                importInvitation(form)
                    .then(response => {
                        let result = response;
                        if (result.status > 0) {
                            setSnackBarProps({ openSnack: true, variant: 'success', message: result.message });

                        } else {
                            setSnackBarProps({ openSnack: true, variant: 'error', message: result.message });

                        }
                    }).catch(err => {
                        console.log(err)
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Activity import failed.' });
                    })
            } else {

                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Invalid file format, Please upload valid excel file.' });
            }
        } else {
            setSnackBarProps({ openSnack: true, variant: 'error', message: 'Please select a file to upload.' });
        }
        attachmentDocument.target.value = null;
    }

    function importInvitation(obj) {
        return ApiHelper.post(APIURLConstants.INVITATION_EXCEL_IMPORT, obj)
            .then(result => {
                return result.data;
            })
            .catch(err => {
                console.log(err);
            });
    }
    const onSettingClick = () => {
        openSettingDialog.set(true)
    }
    const handleSettingClose = () => {
        openSettingDialog.set(false);
    };
    const multiApprove = () => {
        const selected = allStarticketList
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullAllStarticketList
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const multiReject = () => {
        const selected = allStarticketList
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        const selected1 = fullAllStarticketList
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    // const getMultiEmailNotification = async (multiUsers, requestIds) =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     multiUsers.map((user, index) =>
    //     {
    //         let form = new FormData();
    //         form.append('UserID', user);
    //         form.append('EventID', eventInfo.eventID)
    //         form.append('TemplateType', 'AllStarTicket')
    //         form.append('ID', requestIds[index])
    //         form.append('ModifyBy', userID.value)
    //         form.append('TranportType', 'AllStarTicket')
    //         form.append('ModuleID', 17)
    //         return ApiHelper.post(
    //             APIURLConstants.POST_EMAIL_NOTIFICATION,
    //             form
    //         )
    //             .then((result) =>
    //             {
    //                 return result.data;
    //             })
    //             .catch((err) =>
    //             {
    //                 console.log(err);
    //             });
    //     })
    // }
    // const multisaveAppNotification = (multiUsers, requestIds, status) =>
    // {
    //     multiUsers.map((user, index) =>
    //     {
    //         let payLoad = {
    //             appNotificationID: 0,
    //             userIDs: JSON.stringify(user),
    //             appNotificationTypeID: 1,
    //             eventID: eventData.get().eventID,
    //             moduleID: 17,
    //             recordRefID: requestIds[index],
    //             requestStatus: status,
    //             status: 0,
    //             createdBy: userID.get(),
    //         };
    //         ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res =>
    //         {
    //             console.log(res);
    //             ApiHelper.get(
    //                 APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
    //                     user,
    //                     eventData.get().eventID,
    //                     eventData.get().eventName,
    //                     "AllStarTicket",
    //                     status === 2 ? "Approved" : status === 3 ? "Rejected" : "Pending"
    //                 )
    //             ).then((res) =>
    //             {
    //                 console.log(res);
    //             });
    //         }).catch(err =>
    //         {
    //             console.log(err);
    //         })
    //     })
    // }
    const handleRejectConfirmation = () => {
        let allRejectRequests = [];
        allStarticketList.get().map((row) => {
            if (row.selected === true) {
                allRejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketAllStarComplimentaryID,
                    transportType: 'ALLStarTickets'
                });
            }
        });
        fullAllStarticketList.get().map((row) => {
            if (row.selected === true) {
                allRejectRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketAllStarComplimentaryID,
                    transportType: 'ALLStarTickets'
                });
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        rejectLoader.set(true);
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(allRejectRequests),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 17,
            ModifiedBy: userID.value,
            TemplateType: "ALLStarTickets",
            TransportType: "ALLStarTickets",
            appNotificationTypeID: 1
        })
            .then((res) => {
                if (res.data) {
                    rejectLoader.set(false);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    getAllStarTicketList();
                    // getMultiEmailNotification(multiUsers, rejectRequests);
                    // if (eventData.get().readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, rejectRequests, 3);
                    // }
                }
            })
            .catch((error) => {
                rejectLoader.set(false);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while reject request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const hanldeAllNoteValue = (item) => {
        setAllNoteValue(item)
    }
    const handleApproveConfirmation = () => {
        let allApproveRequests = [];
        // let approveRequests = [];
        // let multiUsers = [];
        allStarticketList.get().map((row) => {
            if (row.selected === true) {
                //console.log(row.actualData)
                allApproveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketAllStarComplimentaryID,
                    transportType: 'ALLStarTickets'
                });
            }
        });
        fullAllStarticketList.get().map((row) => {
            if (row.selected === true) {
                allApproveRequests.push({
                    userID: row.actualData.userID,
                    iD: row.actualData.ticketAllStarComplimentaryID,
                    transportType: 'ALLStarTickets'
                });
            }
        }); const eventInfo = Helper.getStorage('eventInfo');
        approveLoader.set(true)
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(allApproveRequests),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 17,
            ModifiedBy: userID.value,
            TemplateType: "ALLStarTickets",
            TransportType: "ALLStarTickets",
            appNotificationTypeID: 1
        })
            .then((res) => {
                if (res.data) {
                    approveLoader.set(false)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    getAllStarTicketList();
                    // getMultiEmailNotification(multiUsers, approveRequests)
                    // if (eventData.get().readonlyOrHide === 0)
                    // {
                    //     multisaveAppNotification(multiUsers, approveRequests, 2);
                    // }
                }
            })
            .catch((error) => {
                approveLoader.set(false)
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while approve request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const closeNoteDialog = () => {
        approveloading.set({
            loading: false,
            index: 0
        })
        rejectloading.set({
            loading: false,
            index: 0
        })
        openNoteDialog.set(false);
        requestNote.set(null);
    };
    // const getEmailNotification = async (ObjRequest) =>
    // {
    //     let form = new FormData();
    //     form.append('UserID', ObjRequest.item.userID);
    //     form.append('EventID', ObjRequest.item.eventID)
    //     form.append('TemplateType', 'AllStarTicket')
    //     form.append('ID', ObjRequest.item.ticketAllStarComplimentaryID)
    //     form.append('ModifyBy', userID.value)
    //     form.append('TranportType', 'AllStarTicket')
    //     form.append('ModuleID', 17)
    //     return ApiHelper.post(
    //         APIURLConstants.POST_EMAIL_NOTIFICATION,
    //         form
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };
    const saveAppNotification = (obj) => {
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.item.userID),
            appNotificationTypeID: 1,
            eventID: eventData.get().eventID,
            moduleID: 17,
            recordRefID: obj.ticketID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res => {
            //console.log(res);
            ApiHelper.get(
                APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                    obj.item.userID,
                    eventData.get().eventID,
                    eventData.get().eventName,
                    displayName.get(),
                    obj.status === 2 ? "Approved" : obj.status === 3 ? "Rejected" : "Pending"
                )
            ).then((res) => {
                // console.log(res);
            });
        }).catch(err => {
            console.log(err);
        })
    }

    const updateNote = async (value) => {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        newRequestNote['note'] = value;
        const statusReq = {
            eventID: eventData.get().eventID,
            ticketID: newRequestNote.item.ticketAllStarComplimentaryID,
            status: newRequestNote.status,
            modifiedBy: newRequestNote.userID,
            note: newRequestNote.note,
            userID: newRequestNote.item.userID
        };
        ApiHelper.post(APIURLConstants.UPDATE_ALLSTAR_TICKET_STATUS, statusReq)
            .then((res) => {
                if (res.data) {
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Status updated successfully',
                    });
                    // let list = allData.attach(Downgraded).get();
                    // let data = list.find(x => x.actualData.registrationID === req.registrationID)
                    getAllStarTicketList();
                    // getEmailNotification(newRequestNote)
                    if (eventData.get().readonlyOrHide === 0) {
                        saveAppNotification(newRequestNote);
                    }
                    closeNoteDialog();
                }
            })
            .catch((err) => {
                approveloading.set({
                    loading: false,
                    index: 0
                })
                rejectloading.set({
                    loading: false,
                    index: 0
                })
                console.log(err);
            });
    };
    const handlePendingAction = () => {
        pendingAction.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
        const newRequestNote = requestPending.attach(Downgraded).get();
        const statusReq = {
            eventID: eventData.get().eventID,
            ticketID: newRequestNote.ticketID,
            status: newRequestNote.status,
            modifiedBy: newRequestNote.userID,
            note: '',
            userID: newRequestNote.item.userID
        };
        ApiHelper.post(APIURLConstants.UPDATE_ALLSTAR_TICKET_STATUS, statusReq).then(
            async (res) => {
                if (res.data) {
                    rejectloading.set({
                        loading: false,
                        index: 0
                    })
                    approveloading.set({
                        loading: false,
                        index: 0
                    })
                    pendingAction.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    requestPending.set(null);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });

                    await getAllStarTicketList();
                    // await getEmailNotification(newRequestNote)
                    if (eventData.get().readonlyOrHide === 0) {
                        await saveAppNotification(newRequestNote);
                    }

                }
            }
        );
    };
    const onActionClick = (item, index, action) => {
        if (action == 'Approve') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (action == 'Reject') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allStarticketList.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.ticketAllStarComplimentaryID == item.actualData.ticketAllStarComplimentaryID
        );
        let newItem = newData[Index].actualData;

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            status: isStatus,
            userID: userID.get(),
            action,
            item: newItem,
            index,
            note: newItem.note,
            ticketID: newItem.ticketAllStarComplimentaryID,
        });
        openNoteDialog.set(true);
    };
    const onPendingAction = (item, index) => {
        if (item.actualData.requestStatus == 'Approved') {
            approveloading.set({
                loading: true,
                index: index
            })
        }
        else if (item.actualData.requestStatus == 'Rejected') {
            rejectloading.set({
                loading: true,
                index: index
            })
        }
        let newData = [...allStarticketList.attach(Downgraded).get()];
        let Index = newData.findIndex(
            (data) => data.actualData.ticketAllStarComplimentaryID == item.actualData.ticketAllStarComplimentaryID
        );
        let newItem = newData[Index].actualData;
        const isStatus = 1;

        requestPending.set({
            registrationID: newItem.registrationID,
            status: isStatus,
            userID: userID.get(),
            item: newItem,
            index,
            note: newItem.note,
            ticketID: newItem.ticketAllStarComplimentaryID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };
    return (
        <Box
            sx={{
                overflow: 'auto',
                maxHeight: 'calc(100vh - 70px)',
            }}
        >
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : props.modPermission &&
                props.modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none', backgroundColor: 'unset' }}>
                    {allStarticketList.get() ? (
                        <AccordianCommonRequests
                            data={allStarticketList.attach(Downgraded).get()}
                            allData={fullAllStarticketList.attach(Downgraded).get()}
                            // onCheckSelect={onCheckSelect}
                            editRow={editUser}
                            // editTemplate={editTemplate}
                            editSendEmail={editSendEmail}
                            handleClick={redirectToCreate}
                            title={''}
                            showSendAll={false}
                            showEdit={false}
                            buttonTitle={'Add'}
                            deleteRows={deleteTicketList}
                            editAll={editAll}
                            showSearch={true}
                            searchLabel={'Search'}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            // showSettings={true}
                            onActionClick={onActionClick}
                            showRequestStatus={showStatus}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            modPermission={props.modPermission}
                            onPendingAction={onPendingAction}
                            // downloadTemplate={downloadTemplate}
                            callExport={callExport}
                            showExport={true}
                            handleImportInvitation={handleImportInvitation}
                            moduleToShow="All Star Ticket"
                            moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.get().moduleDetails : [],
                                AppConstants.EVENT_MODULES.ALL_STAR_TICKET)}
                            onSettingClick={onSettingClick}
                            showApproveAndReject={true}
                            multiApprove={multiApprove}
                            multiReject={multiReject}
                            approveLoader={approveLoader.get()}
                            rejectLoader={rejectLoader.get()}
                            approveloading={approveloading.get()}
                            rejectloading={rejectloading.get()}
                        />
                    ) : null}
                    {openDialog.get() && (
                        <UserListDialog
                            open={openDialog.get()}
                            title="Add Invitation"
                            handleClose={handleClose}
                            users={eventState.attach(Downgraded).get()}
                            snackBarProps={props.snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getParticipants={getAllStarTicketList}
                            allStarticketList={true}
                            eventParticipants={
                                users.get().length > 0
                                    ? users.attach(Downgraded).get()
                                    : []
                            }
                            allStarTicketInfo={allInvitationInfo.attach(Downgraded).get().length > 0 ? allInvitationInfo.attach(Downgraded).get() : null}
                        />
                    )}
                    {openUserDialog.get() && (
                        <EditTicketList
                            open={openUserDialog.get()}
                            allStarTicketInfo={allStarTicketInfo
                                .attach(Downgraded)
                                .get()}
                            title="Edit Invitation"
                            handleClose={closeEditUser}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getIvitationList={getAllStarTicketList}
                        />
                    )}
                    {openEditTemplate.get() && (
                        <EditTemplate
                            open={openEditTemplate.get()}
                            allStarTicketInfo={allStarTicketInfo
                                .attach(Downgraded)
                                .get()}
                            title="Edit Template "
                            handleClose={closeEditTemplate}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getAllStarTicketList={getAllStarTicketList}
                        />
                    )}
                    {openSendEmail.get() && (
                        <SendEmail
                            open={openSendEmail.get()}
                            allStarTicketInfo={allStarTicketInfo
                                .attach(Downgraded)
                                .get()}
                            title="Send Email"
                            handleClose={closeSendEmail}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getAllStarTicketList={getAllStarTicketList}
                        />
                    )}
                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() => {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                    {openSettingDialog.get() && (
                        <TicketSettingsDialog
                            open={openSettingDialog.get()}
                            title="Add Settings"
                            handleClose={handleSettingClose}
                            users={overallParticipants.attach(Downgraded).get()}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            eventParticipants={
                                overallParticipants.get().length > 0
                                    ? overallParticipants.attach(Downgraded).get()
                                    : []
                            }
                            ModuleType={3}
                        />
                    )}
                </Paper>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() => handlePendingAction(pendingAction)}
                    onCancelClick={() => {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                        approveloading.set({
                            loading: false,
                            index: 0
                        })
                        rejectloading.set({
                            loading: false,
                            index: 0
                        })
                    }}></PendingActionDialog>
            }
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    onCancelClick={() => {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    onCancelClick={() => {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};
export default TicketList;
